<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 p-0">
        <div v-if="!projectId">
          <PageHeader :page-title="'Hours and payments reports'" />
          <div
            v-if="getProjects.length"
            class="d-flex justify-content-start bg-white p-4"
          >
            <multiselect
              class="multiselect-projects"
              v-model="currentProject"
              :options="getProjects"
              :placeholder="'Select project'"
              :track-by="'name'"
              :label="'name'"
              :allow-empty="false"
              :showLabels="false"
              @select="getProjectPage"
            />
          </div>
        </div>
        <TableWithDetails
          v-if="getCurrentProject"
          :key="projectId"
          :current-project="getCurrentProject"
          :projects-list="getProjects"
          @changeProject="getProjectPage($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import TableWithDetails from '@components/tables/TableWithDetails'
  import PageHeader from '@components/PageHeader'

  export default {
  components: {
    PageHeader,
    TableWithDetails
  },
  data () {
    return {
      projectId: null,
      currentProject: null
    }
  },
  created () {
    if (!this.getProjects.length) {
      this.$api.projects.getProjects()
    }
    this.projectId = this.$route.params.id
    this.$watch(
      () => this.$route.params,
      (toParams) => {
        this.projectId = toParams.id
        this.$forceUpdate()
      }
    )
  },
  computed: {
    ...mapGetters({
      getProjects: 'projects/getProjects'
    }),
    getCurrentProject () {
      if (this.projectId) {
        return this.getProjects.find(project => project.id === +this.projectId)
      }

      return this.currentProject
    }
  },
  methods: {
    getProjectPage (data) {
      this.$router.push({ name: 'h-p-report', params: { id: data.id } })
      this.projectId = data.id
    }
  }
}
</script>

<style lang="scss" scoped>
.multiselect-projects {
  width: 200px;
}
</style>
